import { Avatar, Box, Chip, Stack, SxProps } from '@mui/material';
import { ChipStepperLocation } from 'Images';

interface IChipStepper {
  steps: number;
  activeStep: number;
  color?: string;
}
export const ChipStepper = ({
  steps,
  activeStep,
  color = '#B756FF',
}: IChipStepper) => {
  const chipStyle: SxProps = {
    width: '40px',
    height: '6px',
    border: `1px solid ${color}`,
  };

  const chips: React.ReactNode[] = [];
  for (let i = 0; i < steps; i++) {
    chips.push(
      <Box key={i} sx={{ position: 'relative' }}>
        <Chip
          sx={{ ...chipStyle, bgcolor: i <= activeStep ? color : undefined }}
        />
        {i === activeStep && (
          <Avatar
            alt=''
            src={ChipStepperLocation}
            sx={{
              position: 'absolute',
              width: '25px',
              height: '25px',
              left: '50%',
              top: 0,
              transform: 'translate(-50%,-35%)',
            }}
          />
        )}
      </Box>
    );
  }

  return (
    <Stack direction='row' columnGap='6px'>
      {chips}
    </Stack>
  );
};
